<app-breadcrumb [master]="'Należności'" [parentName]="'Raporty'" [name]="'Import'"></app-breadcrumb>
<div class="commission-import" fxLayout="column" fxLayoutGap="15px" [formGroup]="receivablesImportForm"  *ngIf="(userPermissions | async).receivables.write">
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100">
      <div fxLayout="row">
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Dane importu</h3>
          </div>

          <app-file-drag-and-drop
            [multiple]="false"
            [generateOutput]="true"
            (fileSelected)="fileSelected($event)"
            [maxSize]="fileMaxSize"
            acceptMime="text/csv"
          ></app-file-drag-and-drop>

          <mat-error *ngIf="receivablesImportForm.get('fileContent').hasError('backendError')">
            {{receivablesImportForm.get('fileContent').getError('backendError')}}
          </mat-error>


          <div fxLayout="row">
            <app-dict
              fxFlex="100"
              label="Firma"
              dictType="company"
              [control]="companyControl"
              [required]="true"
            ></app-dict>
          </div>

          <div fxLayout="row" >
            <app-dict-insurance-companies
              fxFlex="100" label="TU"
              [required]="insuranceRequired"
              [control]="insuranceCompanyControl"
              [companyId]="importCompanyId"
              (selectedInsuranceCompany)="selectedInsuranceCompany = $event"
              [hideChildren]="true"
            ></app-dict-insurance-companies>
          </div>

          <div fxLayout="row">
            <app-dict
              fxFlex="100" [required]="insuranceRequired"
              [control]="importerControl"
              [dictType]="'receivables_importer_' + selectedInsuranceCompany?.key"
              matTooltip="Najpierw wybierz TU"
              matTooltipPosition="left"
              [matTooltipDisabled]="!!selectedInsuranceCompany"
              label="Importer"
              (availableItems)="onAvailableImportersChange($event)"
            ></app-dict>
          </div>

        </mat-card>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="import()" [class.spinner]="processingRequest"
            [disabled]="!receivablesImportFormValid"
            mat-stroked-button color="primary"><mat-icon>publish</mat-icon> <span> Importuj</span></button>
  </div>
</div>
